// extracted by mini-css-extract-plugin
export default {"container":"Title_container__YoUNT","text":"Title_text__MPQrQ","link":"Title_link__LsbRM","seattle":"Title_seattle__GLt58"};